export default __webpack_public_path__ + "static/Logo-Bitcoin-d0a1ce55e106304d4bdf7d9adf5e9094.png";